import Banner from "ds/components/Banner";
import Button from "ds/components/Button";
import FeedbackActions from "ds/components/Feedback/Actions";
import Link from "ds/components/Link";

import { DASHBOARD_WIDGETS_STACKS_REQUIRING_ATTENTION_MIGRATION_GUIDE_URL } from "../constants";

type DashboardWidgetsStacksRequiringAttentionReadyToMigrateCalloutProps = {
  onMigrate: () => void;
  migrateLoading: boolean;
  disabled: boolean;
};

const DashboardWidgetsStacksRequiringAttentionReadyToMigrateCallout = ({
  onMigrate,
  migrateLoading,
  disabled,
}: DashboardWidgetsStacksRequiringAttentionReadyToMigrateCalloutProps) => {
  return (
    <Banner
      variant="warning"
      fullWidth
      title="Terragrunt support within Terraform stacks is deprecated"
    >
      The legacy Terragrunt support within Terraform stacks will be removed on October 31, 2026.
      <FeedbackActions>
        <Button
          variant="primary"
          size="small"
          onPress={onMigrate}
          loading={migrateLoading}
          disabled={disabled}
        >
          Migrate all
        </Button>
        <Link
          size="small"
          href={DASHBOARD_WIDGETS_STACKS_REQUIRING_ATTENTION_MIGRATION_GUIDE_URL}
          target="_blank"
        >
          Terragrunt migration guide
        </Link>
      </FeedbackActions>
    </Banner>
  );
};

export default DashboardWidgetsStacksRequiringAttentionReadyToMigrateCallout;
